angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.stateMachineOrderDetailController', ['$scope', 'virtoCommerce.marketplaceModule.webApi',
        function ($scope, smApi) {
            var blade = $scope.blade;
            blade.headIcon = 'far fa-plus-square';
            blade.title = '';

            function initializeBlade(data) {
                blade.currentEntity = data;
                blade.originalEntity = data;
                blade.isLoading = false;
            }

            $scope.setForm = function (form) { blade.formScope = form; }

            $scope.doAction = function (trigger) {
                blade.isLoading = true;
                smApi.fireStateMachineInstanceTrigger({ instanceId: blade.currentEntity.id, trigger: trigger, entityId: blade.parentBlade.currentEntity.id }, {}, function (data) {
                    blade.refresh(true);
                });
                blade.isLoading = false;
            }

            blade.refresh = function (parentRefresh) {
                blade.isLoading = true;
                smApi.getStateMachineInstanceById({ instanceId: blade.currentEntity.id }, function (data) {
                    initializeBlade(data);

                });

                if (parentRefresh) {
                    blade.parentBlade.refresh(parentRefresh);
                }

            };

            blade.refresh();
    }]);
